import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

import {lang} from '../i18n'
import 'dayjs/locale/uk'
import 'dayjs/locale/en'
import 'dayjs/locale/ru'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.locale(lang)

export function formatDateTime(str: string) {
  return dayjs(str).format('lll')
}

export function formatDateTimeRelative(str: string) {
  return dayjs().to(dayjs(str));
}